<!-- 新增广告接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure.vue"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          "adType": 0,
          "connectType": 2,
          "serveRange": 0,
          "validFrom": "20160906181930",
          "validTo": "20160906181930",
          "availableType": "0,1"
        },
        responseCode: {
          "data": {
            "adId": 8005
          }, "message": "业务成功", "resultCode": 0, "status": 1
        },
        infoData: {
          explain: "第三方接入系统请求智慧停车开放平台新增广告",
          t_url: this.commonUrls.test + "newAd",
          p_url: this.commonUrls.prod + "newAd",
          precondition: "无",
          fitSystem: "VEMS传统停车场，云停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {
                info1: 'adType',
                info2: '是',
                info3: 'Integer',
                info4: '广告类型，0微信消息广告 1APP启动页广告 2介绍图配置 3发现轮播广告 4轮播广告 5弹窗广告 6通知页广告 7车场服务广告 8代缴页广告'
              },
              {
                info1: 'connectType',
                info2: '否',
                info3: 'Integer',
                info4: '连接类型。adType=0,4时，必填。adType=0时，0第三方 1智慧停车 2泊链;adType=4时，0自由广告 1泊链广告'
              },
              {
                info1: 'theme',
                info2: '否',
                info3: 'String',
                info4: '广告主题。adType=0且connectType=0,1时;adType=1,2,3,4,5,6,7,8时必填；当adType=4时，由主标题-副标题组成，主副标题用横线隔开'
              },
              {
                info1: 'pic',
                info2: '否',
                info3: 'String',
                info4: '图片（图像流文件的Base64编码）。adType=0且connectType=1时;adType=1,2,3,4,5,6,7,8时，必填。'
              },
              {info1: 'url', info2: '否', info3: 'String', info4: '链接。adType=0且connectType=0时;adType=1,2,3,4,5,6,7,8时，必填'},
              {
                info1: 'countdow',
                info2: '否',
                info3: 'Integer',
                info4: '倒计时/频率。adType=1时标识倒计时;adType=6时标识频率（每用户每天展示的次数），必填'
              },
              {info1: 'content', info2: '否', info3: 'String', info4: '内容。adType=0且connectType=0,1时，必填'},
              {info1: 'validFrom', info2: '是', info3: 'String', info4: '有效期的开始时间，yyyyMMddHHmmss'},
              {info1: 'validTo', info2: '是', info3: 'String', info4: '有效期的结束时间，yyyyMMddHHmmss'},
              {info1: 'serveRange', info2: '否', info3: 'Integer', info4: '投放范围。0全局，1局部车场。adType=0,4,5,7时，必填'},
              {info1: 'parkCodes', info2: '否', info3: 'String', info4: '可用车场编码列表,多个英文逗号分割，长度不能超过500。serveRange为1时，必填。'},
              {info1: 'cityCodes', info2: '否', info3: 'String', info4: '当adType=8时必填；投放城市编码列表（市级编码，具体编码请联系开放平台团队获取）, 多个英文逗号分割，长度不能超过500。'},
              {
                info1: 'availableType',
                info2: '否',
                info3: 'String',
                info4: '适用消息类型列表,多个英文逗号分割。adType=0时，标识：0进场消息 1出场消息 2交费消息 3充值消息 ' +
                  '4领商家券 5领通用券 6欠费消息;adType=7时，标识：0进场消息 1出场消息，必填; adType=8时，标识：0-弹窗广告 1-轮播广告  多种以英文逗号隔开'
              },
              {
                info1: 'adLocation',
                info2: '否',
                info3: 'String',
                info4: '广告位置。adType=5时,0查费页 1支付成功页，必填； 当adType=4时，游客支付:0输入车牌页 1查费页 2支付成功页  会员支付:3通用支付页面 4支付成功页  领券:5输入车牌页 6领券成功页，7领券状态页；多选时使用‘,’分格'
              },
            ]
          },],
          R_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'adId', info2: '是', info3: 'Integer', info4: '广告ID'},
            ]
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{tableHead: '状态码', tdName: 'info1'}, {tableHead: '说明', tdName: 'info2'}],
            td: [{info1: '000110', info2: '失败',}, {info1: '00110000', info2: '失败',}, {info1: '110000', info2: '失败',}]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ad/newAd.vue